import React from "react";
import { Link, useLocation } from "react-router-dom";
import { ShoppingBag, Menu, X } from "lucide-react";
import { useCart } from "@/context/CartContext";

export default function Navbar() {
  const { count, setOpen } = useCart();
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const loc = useLocation();

  React.useEffect(() => { setMobileOpen(false); }, [loc.pathname]);

  const links = [
    { to: "/", label: "Home" },
    { to: "/shop", label: "Shop" },
    { to: "/about", label: "Story" },
    { to: "/community", label: "Cause" },
  ];

  return (
    <header className="fixed top-0 inset-x-0 z-50 glass-nav" data-testid="site-navbar">
      <div className="ankara-strip" />
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-5 flex items-center justify-between">
        <Link to="/" className="flex items-baseline gap-2" data-testid="nav-logo">
          <span className="font-display text-2xl md:text-3xl tracking-tight text-white">DaviD<span style={{color:"var(--davide-gold)"}}>É</span></span>
          <span className="overline hidden sm:inline" style={{color: "var(--davide-muted)"}}>Global Fashion</span>
        </Link>

        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <Link key={l.to} to={l.to}
              data-testid={`nav-${l.label.toLowerCase()}-link`}
              className={`text-sm uppercase tracking-[0.18em] font-medium transition-colors ${loc.pathname === l.to ? "text-[var(--davide-gold)]" : "text-white/80 hover:text-[var(--davide-gold)]"}`}>
              {l.label}
            </Link>
          ))}
        </nav>

        <div className="flex items-center gap-4">
          <button data-testid="open-cart-btn" onClick={() => setOpen(true)}
            className="relative text-white hover:text-[var(--davide-gold)] transition-colors">
            <ShoppingBag size={22} />
            {count > 0 && (
              <span data-testid="cart-count-badge" className="absolute -top-2 -right-2 bg-[var(--davide-red)] text-white text-[10px] rounded-full w-5 h-5 flex items-center justify-center font-semibold">
                {count}
              </span>
            )}
          </button>
          <button className="md:hidden text-white" data-testid="mobile-menu-btn" onClick={() => setMobileOpen(!mobileOpen)}>
            {mobileOpen ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden border-t border-white/10 bg-black/90" data-testid="mobile-menu">
          <div className="px-6 py-4 flex flex-col gap-4">
            {links.map((l) => (
              <Link key={l.to} to={l.to}
                data-testid={`mobile-nav-${l.label.toLowerCase()}-link`}
                className="text-base uppercase tracking-widest text-white/85 hover:text-[var(--davide-gold)]">
                {l.label}
              </Link>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}
